import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./slice/reducer";

const store = configureStore({
    reducer: rootReducer,
});
store.subscribe(() => console.log("State after dispatch: ", store.getState()));

export default store;
